export default __webpack_public_path__ + "static/media/discord-lg.75570a1e.svg";